import { ArrowLeft } from 'react-feather';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { assetUrl } from '../../../common/helpers';
import UI from '../../../common/UI';

const NotAuthorisedPage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <UI.Section sc={{ compact: true }}>
      <UI.Card sc={{ padding: 8, textAlign: 'center', background: 'gray.50' }}>
        <img src={assetUrl('images/compass.svg')} alt="" height={120} />
        <UI.H2 sc={{ my: 4 }}>
          {t('not_authorised')}
        </UI.H2>
        <UI.Button onClick={() => history.goBack()}>
          <UI.Icon>
            <ArrowLeft />
          </UI.Icon>
          {' '}
          {t('back')}
        </UI.Button>
      </UI.Card>
    </UI.Section>
  );
};

export default NotAuthorisedPage;
